import * as accountActions from 'redux/actions/account.actions'
import * as actions from 'redux/actions/favouriteLinks.actions'

const initialState = {
  lists: [],
  list: null
}

const favouriteLinksReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.getFavouritesListsSuccess.type:
      return {
        ...state,
        lists: payload.lists
      }
    case actions.getFavouritesListSuccess.type:
      return {
        ...state,
        list: payload.list
      }
    case actions.clearFavouritesList.type:
      return {
        ...state,
        list: null
      }
    case accountActions.getAccountDataFailure.type:
      return initialState
    default:
      return state
  }
}

export default favouriteLinksReducer
